import { Outlet, Link, useLocation } from 'react-router-dom'
import { useState } from 'react'
import { Menu, X, ShoppingCart } from 'lucide-react'

const AFFILIATE_LINK = 'https://www.amazon.com/dp/B0G834TQB4?pd_rd_i=B0G834TQB4&pd_rd_w=ZULVk&content-id=amzn1.sym.8c2f9165-8e93-42a1-8313-73d3809141a2&pf_rd_p=8c2f9165-8e93-42a1-8313-73d3809141a2&pf_rd_r=EG9FB0JEPRQXSZC37AJ1&pd_rd_wg=TKxVO&pd_rd_r=cbf9241b-7219-465d-b4d7-5d61c38d22fa&sp_csd=d2lkZ2V0TmFtZT1zcF9kZXRhaWw&th=1&linkCode=ll1&tag=homeinhouse-20&linkId=0736188751f315773494f5e91f97c981&language=en_US&ref_=as_li_ss_tl'

export default function Layout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const location = useLocation()

  const navLinks = [
    { to: '/g6-thumb-camera', label: 'G6 Camera' },
    { to: '/retro-mini-camera', label: 'Retro Style' },
    { to: '/mini-digital-camera', label: 'Mini Cameras' },
    { to: '/faq', label: 'FAQ' },
  ]

  return (
    <>
      {/* Navigation */}
      <nav className="nav">
        <div className="container">
          <div className="nav-inner">
            <Link to="/" className="logo">
              G6<span className="logo-accent">OPTICS</span>
            </Link>

            <div className="nav-links">
              {navLinks.map((link) => (
                <Link 
                  key={link.to}
                  to={link.to} 
                  className={`nav-link ${location.pathname === link.to ? 'active' : ''}`}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href={AFFILIATE_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="nav-cta retro-border-sm"
              >
                Buy Now
              </a>
            </div>

            <button
              className="mobile-menu-btn"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
          {navLinks.map((link) => (
            <Link 
              key={link.to}
              to={link.to} 
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          <a
            href={AFFILIATE_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="nav-cta retro-border-sm"
          >
            Buy Now
          </a>
        </div>
      </nav>

      {/* Page Content */}
      <main>
        <Outlet />
      </main>

      {/* Footer with SEO internal links */}
      <footer className="footer">
        <div className="container">
          <div className="footer-seo-links">
            <div className="footer-column">
              <h4>Products</h4>
              <Link to="/g6-thumb-camera">G6 Thumb Camera</Link>
              <Link to="/mini-digital-camera">Mini Digital Camera</Link>
              <Link to="/retro-mini-camera">Retro Mini Camera</Link>
            </div>
            <div className="footer-column">
              <h4>Resources</h4>
              <Link to="/faq">Frequently Asked Questions</Link>
              <Link to="/">Home</Link>
            </div>
            <div className="footer-column">
              <h4>Legal</h4>
              <Link to="/about">About & Disclosure</Link>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
            </div>
            <div className="footer-column">
              <h4>Shop</h4>
              <a href={AFFILIATE_LINK} target="_blank" rel="noopener noreferrer">
                Buy G6 Camera on Amazon
              </a>
            </div>
          </div>
          <div className="footer-inner">
            <p className="footer-copy">© 2024 G6 Optics. All rights reserved. G6 Thumb Camera - Your pocket-sized retro digital camera.</p>
            <div className="footer-links">
              <Link to="/about">About</Link>
              <Link to="/privacy">Privacy</Link>
              <Link to="/terms">Terms</Link>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
